import styled from 'styled-components'
import { Row, Icon, Select } from 'core/components/ui'
import { font, greys, fontFamily } from 'assets/themes/theme-default'
import { isMobile } from 'react-device-detect'

export const InputWrapper = styled(Row)`
  margin: ${isMobile ? '10px 0 10px' : '10px 0 40px'};
`

export const IconStyled = styled(Icon)`
  margin: 0 0 0 6px;
  color: ${props => props.theme.colors.color2.bg};
`

export const InterTitle = styled.h3`
  font-size: ${font.size.lg};
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.bold.name},`}
    ${fontFamily.bold};
  color: ${greys.dark1};
`
export const SelectWrapper = styled.div`
  margin-bottom: 15px;
`

export const StyledSelect = styled(Select)`
  &&& {
    margin-bottom: '15px';

    width: 45%;
    .ant-select-arrow {
      background: none;
      color: ${props => props.theme.colors.color1.bg};
    }
  }
`
